export default {
    NEW: 'hub_new',
    DEFAULT: 'hub_default',
};
